module.exports = __webpack_public_path__ + "img/92.81b986fe.jpg";